import React, { Fragment } from 'react'
import Link from 'gatsby-link'
import InstagramIcon from 'components/icons/Instagram'
import FacebookIcon from 'components/icons/Facebook'
import PhoneIcon from 'components/icons/Phone'
import horizontalLogoDarkBg from 'static/logos/horizontal-logo-dark-bg.png'
import OfficeGoogleMap from 'components/OfficeGoogleMap'

const StyledFooter = props => (
  <footer
    className="text-white py-16"
    style={{
      background: 'linear-gradient(135deg, #0a2540 0%, #1a1f36 100%)'
    }}
    {...props}
  />
)

const Container = props => (
  <div
    className="container mx-auto px-6 flex flex-col md:flex-row gap-12 md:gap-8"
    {...props}
  />
)

const FooterSection = props => (
  <div className="flex flex-col flex-1" {...props} />
)

const FooterHeading = props => (
  <h3
    className="text-xs font-semibold uppercase tracking-wider mb-6"
    style={{ color: '#8898aa' }}
    {...props}
  />
)

const StyledLink = props => (
  <Link
    className="text-greyMedium block no-underline text-sm leading-relaxed py-1 transition-colors duration-150 hover:text-white"
    {...props}
  />
)

const Address = props => (
  <div className="text-greyMedium text-sm mb-4 leading-relaxed" {...props} />
)

const ExternalLink = props => (
  <a
    className="text-greyMedium flex items-center text-sm no-underline py-2 transition-colors duration-150 hover:text-white"
    {...props}
  />
)

const Hour = props => (
  <div
    className="text-sm leading-relaxed py-0.5 flex justify-between"
    style={{ color: '#c1c9d2' }}
    {...props}
  />
)

const SocialLink = ({ href, icon: Icon, label }) => (
  <a
    href={href}
    className="flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-150 hover:bg-navyLight"
    style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
    aria-label={label}
  >
    <Icon size="1.25rem" fill="currentColor" className="text-greyMedium" />
  </a>
)

const Footer = () => (
  <Fragment>
    <OfficeGoogleMap isMarkerShown />
    <StyledFooter>
      <Container>
        {/* Brand & Contact */}
        <FooterSection>
          <Link to="/" className="flex items-center">
            <img
              style={{ height: '44px', marginBottom: '24px' }}
              src={horizontalLogoDarkBg}
              alt="Oregon City Smiles"
            />
          </Link>
          <Address>
            19731 South Hwy 213
            <br />
            Oregon City, OR 97045
          </Address>
          <ExternalLink href="tel:503-518-3384">
            <PhoneIcon className="mr-3" size="1.25rem" fill="currentColor" />
            503-518-3384
          </ExternalLink>

          {/* Social Links */}
          <div className="flex gap-3 mt-4">
            <SocialLink
              href="https://www.facebook.com/Oregon-City-Smiles-328506251331414"
              icon={FacebookIcon}
              label="Facebook"
            />
            <SocialLink
              href="https://www.instagram.com/oregoncitysmiles"
              icon={InstagramIcon}
              label="Instagram"
            />
          </div>
        </FooterSection>

        {/* Navigation */}
        <FooterSection>
          <FooterHeading>Navigation</FooterHeading>
          <StyledLink to="/">Home</StyledLink>
          <StyledLink to="/about_us">About Us</StyledLink>
          <StyledLink to="/appointments">Appointments</StyledLink>
          <StyledLink to="/emergency_care">Emergency Care</StyledLink>
          <StyledLink to="/treatments">Treatments</StyledLink>
          <StyledLink to="/faqs">FAQs</StyledLink>
          <StyledLink to="/contact">Contact</StyledLink>
        </FooterSection>

        {/* Hours */}
        <FooterSection>
          <FooterHeading>Office Hours</FooterHeading>
          <div className="space-y-1">
            <Hour>
              <span>Monday</span>
              <span>8:00 AM - 5:00 PM</span>
            </Hour>
            <Hour>
              <span>Tuesday</span>
              <span>8:00 AM - 5:00 PM</span>
            </Hour>
            <Hour>
              <span>Wednesday</span>
              <span>8:00 AM - 5:00 PM</span>
            </Hour>
            <Hour>
              <span>Thursday</span>
              <span>8:00 AM - 5:00 PM</span>
            </Hour>
            <Hour style={{ color: '#697386' }}>
              <span>Friday</span>
              <span>Closed</span>
            </Hour>
            <Hour style={{ color: '#697386' }}>
              <span>Saturday</span>
              <span>Closed</span>
            </Hour>
            <Hour style={{ color: '#697386' }}>
              <span>Sunday</span>
              <span>Closed</span>
            </Hour>
          </div>
        </FooterSection>

        {/* CTA */}
        <FooterSection>
          <FooterHeading>Ready to visit?</FooterHeading>
          <p className="text-greyMedium text-sm mb-6 leading-relaxed">
            Schedule your appointment today and experience modern dental care in
            a caring environment.
          </p>
          <Link
            to="/appointments"
            className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white font-medium text-sm rounded-lg transition-all duration-150 hover:bg-primaryDark"
            style={{
              boxShadow:
                '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)'
            }}
          >
            Book Appointment
          </Link>
        </FooterSection>
      </Container>

      {/* Bottom bar */}
      <div
        className="container mx-auto px-6 mt-12 pt-8"
        style={{ borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}
      >
        <p className="text-xs" style={{ color: '#697386' }}>
          &copy; {new Date().getFullYear()} Oregon City Smiles. All rights
          reserved.
        </p>
      </div>
    </StyledFooter>
  </Fragment>
)

export default Footer
